<template lang="pug">
.featured-item.card
  .media(@click="openItem")
    DynamicMedia(:config="media")
  .details
    h4.title(v-if="title") {{ title }}
    .description(v-if="shortDescription" v-html="shortDescription")
    RogueButton(
      v-if="type === 'PRODUCT' || (customButtonText && type === 'BANNER')"
      @click="openItem"
      width="full"
      color="black"
      size="m"
    ) {{ customButtonText || 'Shop Now' }}
</template>

<script setup lang="ts">
import { useRogue } from '../../js/rogue'

const props = withDefaults(defineProps<{
  type?: 'PRODUCT' | 'BANNER',
  media?: object,
  // @TODO: For a later update in the component
  showRatings?: boolean,
  title?: string,
  shortDescription?: string,
  customButtonText?: string,
  link?: string,
} > (), {
  type  : 'PRODUCT',
  media : () => ({
    src: '/Rogue%20App%20Dashboard/placeholder_ssedja.png',
  }),
  showRatings      : false,
  title            : '',
  shortDescription : '',
  customButtonText : '',
  link             : '',
})

const rogue = useRogue()

function openItem() {
  // @TODO: to be discussed
  if (rogue && rogue.appContext && props.link) {
    rogue.emitToApp?.('open_in_webview', { url: props.link })
  }
}
</script>

<style scoped lang="scss">
.card {
  display: flex;
  flex-direction: column;
  margin-bottom: $space-m;
  box-shadow: rgba($color-gray-dark, 0.45) 0 $space-xs $space-xxs 0;
}
.media:deep(.media-wrap > .media-link) {
  // Ignore the image link if any
  display: none;
}
.details {
  padding: $space-s;
  font-size: $size-xs;
}
.title {
  font-size: $size-s;
  margin-bottom: $space-xxs;

  &:last-child {
    margin-bottom: 0;
  }
}
.description {
  margin-bottom: $space-s;
}
</style>
